export const VIEW_NOTICE = "VIEW_NOTICE"
export const VIEW_NOTICE_SUCCESS = "VIEW_NOTICE_SUCCESS"
export const VIEW_NOTICE_FAILED = "VIEW_NOTICE_FAILED"